import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * Loading state placeholder
 */
@customElement('lua-loading')
export class LuaLoading extends LitElement {
  protected override render() {
    return html`Loading...`;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'lua-loading': LuaLoading;
  }
}
